import { render, staticRenderFns } from "./comp_ProductImagesDialog.vue?vue&type=template&id=314641ab&scoped=true&"
import script from "./comp_ProductImagesDialog.vue?vue&type=script&lang=js&"
export * from "./comp_ProductImagesDialog.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductImagesDialog.vue?vue&type=style&index=0&id=314641ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314641ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
